/**
 * Akademie-Punktesystem, Phase 1 (backlog.md -> [Punkt 34]) - rein clientseitig
 * (localStorage), exakt dasselbe bewusste Zwischenmuster wie Watchlist/Depot ohne Login
 * (siehe lib/local-portfolio/store.ts: "Feedback-Runde 2, Punkt 5... bewusste
 * Zwischenentscheidung"). Ein Supabase-Sync fuer eingeloggte Nutzer (geraeteuebergreifend)
 * ist ein natuerlicher naechster Schritt, aber bewusst NICHT Teil dieser ersten Charge -
 * Erik selbst: "großes, mehrteiliges Feature - realistisch eigene Session/mehrere
 * Chargen". Punkte: 10 je richtig beantworteter Quiz-Frage, kein Punktabzug bei falscher
 * Antwort (Ausprobieren soll sich nie negativ anfuehlen).
 */

const PROGRESS_KEY = "ek_academy_progress_v1";
const POINTS_PER_CORRECT_ANSWER = 10;

export interface AcademyQuizResult {
  slug: string;
  correctCount: number;
  totalQuestions: number;
  completedAt: string;
}

interface AcademyProgress {
  results: AcademyQuizResult[];
}

function readProgress(): AcademyProgress {
  if (typeof window === "undefined") return { results: [] };
  try {
    const raw = localStorage.getItem(PROGRESS_KEY);
    return raw ? (JSON.parse(raw) as AcademyProgress) : { results: [] };
  } catch {
    return { results: [] };
  }
}

function writeProgress(progress: AcademyProgress): void {
  if (typeof window === "undefined") return;
  localStorage.setItem(PROGRESS_KEY, JSON.stringify(progress));
}

/** Speichert (oder ersetzt) das Ergebnis eines Quiz-Durchlaufs fuer einen Artikel - ein
 * wiederholter Versuch ueberschreibt den vorherigen (das neueste Ergebnis zaehlt fuer die
 * Punktzahl), verhindert doppeltes Punkten durch mehrfaches Wiederholen desselben Quiz. */
export function saveAcademyQuizResult(slug: string, correctCount: number, totalQuestions: number): void {
  const progress = readProgress();
  const withoutSlug = progress.results.filter((r) => r.slug !== slug);
  writeProgress({
    results: [...withoutSlug, { slug, correctCount, totalQuestions, completedAt: new Date().toISOString() }],
  });
}

export function getAcademyQuizResult(slug: string): AcademyQuizResult | undefined {
  return readProgress().results.find((r) => r.slug === slug);
}

export function getAcademyTotalPoints(): number {
  return readProgress().results.reduce((sum, r) => sum + r.correctCount * POINTS_PER_CORRECT_ANSWER, 0);
}

export function getAcademyCompletedCount(): number {
  return readProgress().results.length;
}
